// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"5ed8dd08","84":"2a849468","582":"d17a99a8"}[chunkId] + ".chunk.css";
};